jQuery(document).ready(function ($) {
  var $categories = $(".box-carousel-categories .swiper");

  if (!$categories.length) return;

  $categories.each(function (index, element) {
    new Swiper(element, {
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 10,
      speed: 600,
      rewind: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: $(element).parent().find(".carousel-nav.next")[0],
        prevEl: $(element).parent().find(".carousel-nav.prev")[0],
      },
      //   pagination: {
      //     el: $(element).parent().parent().find(".carousel-pagination")[0],
      //     clickable: true,
      //     dynamicBullets: true,
      //   },
      breakpoints: {
        768: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        992: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
        1200: {
          slidesPerView: 6,
          slidesPerGroup: 6,
        },
      },
    });
  });
});
